import type { UserProfile } from '@/hooks/useUserStore';

export const SIGNUP_PROFILE_DRAFT_KEY = 'youraura_signup_profile_draft';

export type SignupProfileDraft = Pick<
  UserProfile,
  | 'name'
  | 'email'
  | 'birthDate'
  | 'birthTime'
  | 'birthTimeConfidence'
  | 'birthPlace'
  | 'primaryIntention'
>;

export function saveSignupProfileDraft(draft: SignupProfileDraft) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(SIGNUP_PROFILE_DRAFT_KEY, JSON.stringify(draft));
}

export function getSignupProfileDraft(): Partial<UserProfile> | null {
  if (typeof window === 'undefined') return null;

  const rawDraft = window.localStorage.getItem(SIGNUP_PROFILE_DRAFT_KEY);
  if (!rawDraft) return null;

  try {
    return JSON.parse(rawDraft) as Partial<UserProfile>;
  } catch {
    window.localStorage.removeItem(SIGNUP_PROFILE_DRAFT_KEY);
    return null;
  }
}

export function clearSignupProfileDraft() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(SIGNUP_PROFILE_DRAFT_KEY);
}
